import React from "react";
import ComingSoon from "components/Common/ComingSoon";

const Withdraw = () => {
  return (
    <div>
      <ComingSoon />
    </div>
  );
};

export default Withdraw;
